import { Injectable } from '@angular/core';
import { NetService } from './net.service';
import { BoardStatusObject, chatRecordModel } from '../classes';
import * as moment from 'moment';
import { map, catchError, of, Observable, BehaviorSubject, take } from 'rxjs';
import { eTaskPriorityText } from '../enums';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
unreadSupportCount = new BehaviorSubject<number>(0);

constructor(
  private netService: NetService
) { }

  getAllBoardTickets(filters: any,userId: string) {
    return this.netService.postJavaNotification(`service-board/find-all-by-filter`, filters).pipe(
      map(val => {
        return {
          success: true,
          data: val
        }
      }),
      catchError(err => {
        return of({
          success: false,
          error: err
        })
      })
    );
  }

  getTicketRecoerds(ticketId: string): Observable<chatRecordModel[]>{
    return this.netService.getJavaNotification(`ticket-record?ticketIds=${ticketId}&size=20000`);
  } 

  setMessagesAsSeen(ticketId: string, userId: string) {
    return this.netService.patchJavaNotification(`ticket-record/mark-as-seen?ticketId=${ticketId}&userId=${userId}`, {});
  }

  buildStatusObject(type: string, startDate: any): BoardStatusObject | null {
    let text,status = eTaskPriorityText.low,days = 0
    if(type === 'ticketStatus') {
      return {type: type, status: this.statusClassMapper(startDate), statusClass: this.statusClassMapper(startDate), days: days, text: startDate.replace(/^./, function(str: any){ return str.toUpperCase(); }) };
    }
    else if(type === 'ticketStatusDisplay' || startDate === 'blocked') {
      return {type: type, status: this.statusClassMapper(startDate.toUpperCase()), statusClass: this.statusClassMapper(startDate.toUpperCase()), days: days, text: startDate.replace(/^./, function(str: any){ return str.toUpperCase(); }).replace("_","-") };
    }
    else if(type === 'taskSidbar') {
      return {type: type, status: this.statusClassMapper(startDate), statusClass: this.statusClassMapper(startDate), days: 0, text: startDate.toLowerCase().replace(/^./, function(str: any){ return str.toUpperCase(); }).replace("_","-")};
    }
    return null
  }

  statusClassMapper(status: any): string {
    switch (status) {
      case 'IN_PROGRESS':
        return 'inProgress'
      case 'COMPLETED':
        return 'completed'
      case 'OPEN':
        return 'open'
      case 'BLOCKED':
        return 'blocked'
      case 'CANCELED':
        return 'canceled'
      case 'SKIPPED':
        return 'skipped'
      case 'ARCHIVE' :
        return 'archived'
      default:
        return ''
    }
  }

  createTicketRecord(body: any) {
    return this.netService.postJavaNotification(`ticket-record`, body);
  }

  updateTicketSatge(ticketId: string,userId: string) {
    const body = {
      "stage": "In-progress",
    }
    return this.netService.patchJavaNotification(`service-board/ticket/${ticketId}?userId=${userId}`,body);
  }

  getServiceTicket(id: string): Observable<any> {
    return this.netService.getJavaNotification(`service-board/ticket/${id}`);
} 

  setTicketRate(body: any) {
    return this.netService.postJavaNotification(`ticket/rate/create`, body);
  }

  getUnreadSupportCount(userId: string): void {
    this.netService
      .getJavaNotification<{count:number}>(
        'ticket-record/count-unseen',
        {userId: userId}
      ).pipe(take(1)).subscribe(result =>{
        this.unreadSupportCount.next(result.count);
    })
  }

  getCallTranscript(callTranscriptId: string) {
    return this.netService.getJavaNotification(`ticket-call-log/phone/recording/transcript/${callTranscriptId}`)
}

}
